import type { CompetitionTeamDetailed, UpdateCompetitionTeamRequest } from '@clsplus/api-types/api-admin'

import { getTokens } from '../../helpers/auth'

export function updateCompetitionTeamDetails(
  competitionId: string,
  stageId: string,
  formData: UpdateCompetitionTeamRequest
): Promise<CompetitionTeamDetailed> {
  const tokens = getTokens()

  return fetch(`${import.meta.env.VITE_API_URL}admin/competitions/${competitionId}/competition-teams/${stageId}`, {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${tokens?.accessToken}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formData),
  })
    .then(response => response.json())
    .then(data => {
      if (data.error) {
        throw new Error(data.error)
      }

      return data
    })
}
